import { selectBasketDiscount } from 'containers/OrderDetails/basketSlice'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import DiscountPopup from './DiscountPopup'
import { useReduxSelector } from 'store'
import React from 'react'

const Discounts: React.FC = () => {
  const discount = useReduxSelector(selectBasketDiscount)
  const { popup, openPopup } = usePopupState()

  const { t } = useTranslation('basket')

  return (
    <div className='orderInfoButton'>
      {popup === 'discounts' && <DiscountPopup />}
      <div className='title'>
        <div>
          <span>{t('discounts')}</span>
        </div>
      </div>

      <div className='orderInfo__button'>
        <button
          className='button --coupon'
          onClick={() => {
            openPopup('discounts')
          }}>
          {discount?.title || t('addDiscountCoupon')}
        </button>
      </div>
    </div>
  )
}

export default Discounts